<template>
    <div v-if="!success">
        <h1><div class="icon__lead"></div>Заполните форму</h1>
        <div class="w-modal__form">
            <form @submit.prevent="submit">
                <div class="form-control__wrap" :class="{'is-invalid': errors.name}">
                    <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
                    <input type="text" class="form-control" v-model="form.name" placeholder="Имя и фамилия">
                    <div class="invalid-sup">*</div>
                </div>
                <div class="form-control__wrap" :class="{'is-invalid': errors.email}">
                    <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}</div>
                    <input type="text" class="form-control" v-model="form.email" placeholder="E-mail">
                    <div class="invalid-sup">*</div>
                </div>
                <div class="form-control__wrap" :class="{'is-invalid': errors.phone}">
                    <div class="invalid-feedback" v-if="errors.phone">{{ errors.phone[0] }}</div>
                    <input type="text" class="form-control mask-phone" v-model="form.phone" placeholder="Контактный телефон">
                    <div class="invalid-sup">*</div>
                </div>

                <div class="form-control__wrap" :class="{'is-invalid': errors.business_type}">
                    <div class="invalid-feedback" v-if="errors.business_type">{{ errors.business_type[0] }}</div>
                    <input type="text" class="form-control" v-model="form.business_type" placeholder="Сфера бизнеса">
                    <div class="invalid-sup">*</div>
                </div>

                <div class="form-control__wrap" :class="{'is-invalid': errors.site}">
                    <div class="invalid-feedback" v-if="errors.site">{{ errors.site[0] }}</div>
                    <input type="text" class="form-control" v-model="form.site" placeholder="Сайт">
                    <div class="invalid-sup">*</div>
                </div>

                <div class="form-control__wrap" :class="{'is-invalid': errors.comment}">
                    <div class="invalid-feedback" v-if="errors.comment">{{ errors.comment[0] }}</div>
                    <textarea class="form-control" v-model="form.comment" placeholder="Комментарий"></textarea>
                </div>

                <div class="form-control__wrap form-button__wrap">
                    <button class="button" type="submit">Оставить заявку</button>
                </div>
            </form>
        </div>
        <div class="w-modal__terms">
            Нажимая на кнопку «Оставить заявку», вы соглашаетесь
            <br>
            с <a href="/terms.pdf">Пользовательским соглашением</a>
        </div>
    </div>
    <div v-else>
        <div class="icon__lead-send"></div>
        <h1 class="h1-lead-send">
            Спасибо! Ваша заявка отправлена!
        </h1>
        <p>В ближайшее время с вами свяжется представитель компании</p>
    </div>
</template>

<script>
import useEvents from "../composables/events";
import {onMounted, ref} from "vue";
import AirDatepicker from "air-datepicker";
import 'air-datepicker/air-datepicker.css'

export default {
    name: "PartnersForm",
    setup(props) {
        onMounted(function () {
        })

        const { errors, sendPartnersForm } = useEvents()
        const success = ref(false)

        const form = ref({
            name: '',
            email: '',
            phone: '',
            site: '',
            business_type: '',
            comment: ''
        })

        const submit = async () => {
            success.value = await sendPartnersForm(form.value)
        }

        return {
            form,
            errors,
            success,
            submit
        }
    }
}
</script>

<style scoped>

</style>
